import { POVSelectorButton } from "./povSelectorButton";
import { TenseSelectorButton } from "./tenseSelectorButton";

export const TenseAndPOV = ({
  containerRef,
  pov,
  tense,
  handleManualTenseChange,
  handleManualPOVChange,
  handleCharacterSelectChange,
  oneOrManyCharacters,
  showLabel,
  showPOVLabel,
  showTenseLabel,
  className,
  collisionBoundarySelector,
  allowWrap,
}) => {
  // Use separate props if provided, otherwise fall back to showLabel for backward compatibility
  const povLabelVisible = showPOVLabel !== undefined ? showPOVLabel : showLabel;
  const tenseLabelVisible = showTenseLabel !== undefined ? showTenseLabel : showLabel;

  return (
    <div
      ref={containerRef}
      className={`flex gap-[8px] ${allowWrap ? "flex-wrap" : ""} ${className}`}
    >
      <POVSelectorButton
        pov={pov}
        handleManualPOVChange={handleManualPOVChange}
        handleCharacterSelectChange={handleCharacterSelectChange}
        oneOrManyCharacters={oneOrManyCharacters}
        showLabel={povLabelVisible}
        collisionBoundarySelector={collisionBoundarySelector}
      />
      <TenseSelectorButton
        tense={tense}
        setTense={handleManualTenseChange}
        showLabel={tenseLabelVisible}
      />
    </div>
  );
};
